import { ContactTranslation } from '@/assets/locales/views/contact/contact.translation.en.ts';

export const contactTranslation: ContactTranslation = {
  backToStart: 'Wróć na Start',
  copySuccess: 'Adres email skopiowany do schowka',
  jeronimoCard: {
    bulletPoints: [
      'Wsparcie dotyczące procesu MDR',
      'Wsparcie w zakresie modułu planowania sukcesji',
      'Metodologia oceny wydajności',
      'Treść i struktura programu szkoleniowego',
    ],
    subtitle: 'Pytania dotyczące procesów biznesowych i treści:',
    title: 'Wsparcie Działu Szkoleń i Rozwoju',
  },
  knowmeCard: {
    bulletPoints: [
      'Błędy aplikacji, awarie lub usterki',
      'Problemy z logowaniem i uwierzytelnianiem',
      'Dane nie ładują się lub nie synchronizują poprawnie',
      'Problemy z wydajnością platformy',
      'Interfejs nie działa zgodnie z oczekiwaniami',
      'Błędy przy eksporcie/imporcie danych',
    ],
    subtitle: 'Zgłoś problemy techniczne z platformą:',
    title: 'Wsparcie techniczne jAIn',
  },
  title: 'Kontakt',
};
